import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core'
import { AppointmentModel, PortalRuleType } from '@mmx/shared'

@Component({
  selector: 'mmx-appointment-portal-menu',
  templateUrl: './appointment-portal-menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AppointmentPortalMenuComponent implements OnChanges {
  @Input()
  public appointment: AppointmentModel

  @Input()
  public type: PortalRuleType

  public portalRules = []

  public ngOnChanges(): void {
    if (!this.appointment?.portalRules || !this.type) {
      this.portalRules = []
    }

    this.portalRules = this.appointment.insurances
      .map((insurance) => {
        const portalRule = this.appointment.portalRules.find(({ type, carrierLookups }) => {
          return type === this.type && carrierLookups.some(({ id }) => id === insurance.carrierLookupId)
        })

        if (!portalRule) {
          return
        }

        return {
          ...portalRule,
          insurance,
        }
      })
      .filter(Boolean)
  }
}
